import { render, staticRenderFns } from "./newProject.vue?vue&type=template&id=07db1425&scoped=true&"
import script from "./newProject.vue?vue&type=script&lang=js&"
export * from "./newProject.vue?vue&type=script&lang=js&"
import style0 from "./newProject.vue?vue&type=style&index=0&id=07db1425&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07db1425",
  null
  
)

export default component.exports